// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--d07f2";
export var learn = "style-module--learn--73762";
export var titleEl = "style-module--title-el--4a9a1";